import React from "react"
import Heading from "../../common/Heading"
import "./awards.css"
import { useLanguage } from "../../../context/LanguageContext"

const Awards = () => {
  const { content } = useLanguage()
  const { awards } = content.home

  return (
    <>
      <section className='awards padding'>
        <div className='container'>
          <Heading title={awards.title} subtitle={awards.subtitle} />

          <div className='content grid4 mtop'>
            {awards.items.map((item) => (
              <div className='box' key={item.name}>
                <div className='icon'>
                  <span>
                    <i className={item.iconClass}></i>
                  </span>
                </div>
                <h1>{item.num}</h1>
                <p>{item.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default Awards
